import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Button, GenerateScriptPanel, Text } from './components';
import AuthSection from './components/auth-section';
import { useConfigContext } from './hoc';
import { GenerateScriptPanelProvider } from './hoc/context/generate-script-panel-context';
import { cn } from './utils/class-utils';
import { UpdateProvider } from './contextProvider/context.provider';
function App(_a) {
    var _b = _a.isPreview, isPreview = _b === void 0 ? false : _b, children = _a.children;
    var _c = useState(true), isManageView = _c[0], setIsManageView = _c[1];
    var shouldIncludeAdminModule = useConfigContext().config.shouldIncludeAdminModule;
    var navigate = useNavigate();
    var setupStorageMonitor = function () {
        // Store original setItem method
        var originalSetItem = localStorage.setItem;
        var originalRemoveItem = localStorage.removeItem;
        var originalClear = localStorage.clear;
        // Override setItem
        localStorage.setItem = function (key, value) {
            // Call original method
            originalSetItem.apply(this, [key, value]);
            // Create and dispatch event
            var storageEvent = new StorageEvent('storage', {
                key: key,
                newValue: value,
                oldValue: localStorage.getItem(key),
                storageArea: localStorage,
            });
            window.dispatchEvent(storageEvent);
        };
        // Override removeItem
        localStorage.removeItem = function (key) {
            var oldValue = localStorage.getItem(key);
            // Call original method
            originalRemoveItem.apply(this, [key]);
            // Create and dispatch event
            var storageEvent = new StorageEvent('storage', {
                key: key,
                newValue: null,
                oldValue: oldValue,
                storageArea: localStorage,
            });
            window.dispatchEvent(storageEvent);
        };
        // Override clear
        localStorage.clear = function () {
            // Call original method
            originalClear.apply(this);
            // Create and dispatch event
            var storageEvent = new StorageEvent('storage', {
                storageArea: localStorage,
            });
            window.dispatchEvent(storageEvent);
        };
        return function () {
            // Restore original methods when cleaning up
            localStorage.setItem = originalSetItem;
            localStorage.removeItem = originalRemoveItem;
            localStorage.clear = originalClear;
        };
    };
    var handleStorageChange = function (event) {
        console.log('Storage changed:', event);
        if (event === null || event === void 0 ? void 0 : event.newValue) {
            navigate('/database-connection');
        }
        else {
            navigate('/');
        }
    };
    useEffect(function () {
        window.addEventListener('storage', handleStorageChange);
        // Set up monitoring for current tab localStorage changes
        var cleanupMonitor = setupStorageMonitor();
        return function () {
            window.removeEventListener('storage', handleStorageChange);
            cleanupMonitor();
        };
    }, []);
    useEffect(function () {
        if (!localStorage.getItem('token')) {
            setTimeout(function () {
                var elements = document.getElementsByClassName('!vas-bg-containerBackground hover:!vas-bg-primary/20 vas-py-2 vas-px-4 vas-rounded-full vas-text-md vas-text-vastypographyAuthLabelTextColor vas-text-vastypographyAuthLabelFontSize vas-font-vastypographyAuthLabelFontWeight');
                if (elements.length > 0) {
                    var button = elements[0];
                    button.click();
                }
            }, 1200);
        }
    }, []);
    return (_jsx(UpdateProvider, { children: _jsxs(_Fragment, { children: [_jsxs("div", { className: cn("\n          h-full flex flex-col pb-10 p-3 vjwMd:p-4\n          ".concat(shouldIncludeAdminModule ? 'gap-4' : 'gap-0', "\n        "), {
                        'overflow-hidden': isPreview,
                        'h-dvh': isPreview,
                    }), children: [!isPreview && shouldIncludeAdminModule && (_jsxs("div", { className: 'flex gap-4 justify-between w-full bg-white shadow-lg px-2 rounded-lg', children: [_jsx(Text, { variant: 'heading', className: 'py-2', children: "Admin View" }), _jsxs("div", { className: 'flex gap-2', children: [_jsx(Button, { variant: 'text', onClick: function () { return setIsManageView(true); }, className: "px-4 py-2 rounded-none text-sm font-medium border-b-2 ".concat(isManageView ? 'border-b-vjwPrimary text-vjwPrimary' : 'border-transparent', " hover:border-b-vjwPrimary hover:text-vjwPrimary"), children: "Manage Status" }), _jsx(Button, { variant: 'text', onClick: function () { return setIsManageView(false); }, className: "px-4 py-2 rounded-none text-sm font-medium border-b-2 ".concat(isManageView ? 'border-transparent' : 'border-b-vjwPrimary text-vjwPrimary', " hover:border-b-vjwPrimary hover:text-vjwPrimary"), children: "Generate Script" })] })] })), _jsx(AuthSection, {}), isManageView ? (_jsx("div", { className: 'w-full bg-gray-50 p-2 rounded-lg', children: children })) : (_jsx("div", { className: 'w-full bg-white p-2 rounded-lg', children: _jsx(GenerateScriptPanelProvider, { children: _jsx(GenerateScriptPanel, { children: children }) }) }))] }), _jsx(ToastContainer, { position: 'top-right', autoClose: 3000, hideProgressBar: true })] }) }));
}
export default App;
